import React from 'react';
import {Link, useParams} from 'react-router-dom';

import clsx from 'clsx';
import {ACCOUNT_TABS} from 'src/constants';
import {USERS_TYPES} from 'src/modules/profile/account/constants';

import {Group} from '@pb/kit-component-group';

import {
    userCountItemDisabled,
    userCountItemValue,
} from './user-count-item.module.styl';

import type {UserSearchStateCriteria} from 'src/constants';

type Props = {
    userType: keyof typeof UserSearchStateCriteria,
    value: number,
};

export const UsersCountItem: React.FC<Props> = ({value, userType}) => {
    const {accountId} = useParams<{accountId?: string, userSearchStateCriteria?: string}>();

    const classes = clsx([!value && userCountItemDisabled]);

    return (
        <Group gap="l" className={classes} alignItems="center">
            <strong style={{width: 150}}>{USERS_TYPES[userType].caption}</strong>
            <span className={userCountItemValue}>
                {value ? (
                    <Link to={`/profile/account/${accountId}/${ACCOUNT_TABS.USERS.name}/${USERS_TYPES[userType].tab}`}>
                        <strong>{value}</strong>
                    </Link>
                ) : '--'}
            </span>
        </Group>
    );
};
